module.exports = __webpack_public_path__ + "img/logo.9eeec721.jpg";